import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function CTASection({ onOpenForm }) {
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="relative py-20 md:py-32 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1629655214242-03523f146285?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc3NjE5Mjg3N3ww&ixlib=rb-4.1.0&q=85"
          alt="Corporate skyline symbolizing brand protection and trademark security"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A0F1A]/90" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#DC2626]/20 border border-[#DC2626]/40 text-[#FCA5A5] text-xs font-bold uppercase tracking-[0.2em] mb-6">
            <ShieldCheck className="w-3.5 h-3.5" />
            Limited Time Offer
          </div>

          <h2
            data-testid="cta-heading"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight mb-6"
          >
            Don't Leave Your Brand Unprotected
          </h2>

          <p className="text-slate-300 text-base sm:text-lg leading-relaxed mb-6 max-w-2xl mx-auto">
            Every day without trademark registration is a day your brand is exposed to potential infringement, copycats, and unauthorized use. The cost of failing to protect your trademark is far greater than the cost of registration. Thousands of businesses have already secured their brands through Trademark Officers. Do not let competitors capitalize on the reputation you have worked so hard to build. Take the first step toward comprehensive brand protection today and gain the peace of mind that comes with knowing your intellectual property is federally protected.
          </p>

          <p className="text-[#2563EB] font-semibold text-sm mb-8">
            Protect Your Brand Today &mdash; Starting at Just $45 + Filing Fee
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={onOpenForm}
              data-testid="cta-register-btn"
              className="bg-[#DC2626] hover:bg-[#B91C1C] text-white h-12 px-8 text-sm font-semibold rounded-lg hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-red-900/30"
            >
              Register My Trademark
              <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
            <Button
              onClick={onOpenForm}
              data-testid="cta-getstarted-btn"
              variant="outline"
              className="border-white/30 text-white hover:bg-white/10 h-12 px-8 text-sm font-semibold rounded-lg transition-all"
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
